import PubSub from 'underpub-js';
import gsap from 'gsap';

var MobileNav = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-MobileNav',
    isOpen: false,
  };

  $.extend(true, this.options, options);
};

MobileNav.prototype.init = function() {
  var self = this;

  self.$primaryNav = self.options.$el.find(
    `.${self.data.baseClass}__primary-nav`,
  );
  self.$secondaryNav = self.options.$el.find(
    `.${self.data.baseClass}__secondary-nav`,
  );
  self.$tertiaryNav = self.options.$el.find(
    `.${self.data.baseClass}__tertiary-nav`,
  );

  self.initAnimation();
  self.initPanelTransitions();

  self.options.$el.find('#mobile-nav-select-location').on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    PubSub.publish("showLanguageSelectorModal");
  });
};

MobileNav.prototype.initPanelTransitions = function() {
  const self = this;

  // Add event listeners for panel triggers
  self.options.$el.on('click', '[data-mobile-panel-trigger]', function(e) {
    e.preventDefault();
    const panelId = $(this).data('mobile-panel-trigger');
    const $panel = self.options.$el.find(`[data-mobile-panel-target="${panelId}"]`);
    if ($panel.length) {
      $panel.addClass('mobile-nav__panel--active');
    }
  });

  // Add event listeners for panel back buttons
  self.options.$el.on('click', '[data-mobile-panel-back]', function(e) {
    e.preventDefault();
    const $panel = $(this).closest('.mobile-nav__panel');
    if ($panel.length) {
      $panel.removeClass('mobile-nav__panel--active');
    }
  });
};

MobileNav.prototype.generateMobileNavTL = function() {
  const self = this;

  const tl = gsap
    .timeline()
    .fromTo(
      self.options.$el,
      {
        duration: 0.1,
        ease: 'expo.out',
        visibility: 'hidden',
        opacity: 0,
      },
      {
        visibility: 'visible',
        opacity: 1,
      },
    )
    .fromTo(
      [self.$secondaryNav, self.$primaryNav, self.$tertiaryNav],
      {
        duration: 0.1,
        ease: 'expo.out',
        y: 15,
        opacity: 0,
      },
      {
        stagger: 0.15,
        y: 0,
        opacity: 1,
      },
      '<.1',
    );

  return tl;
};

MobileNav.prototype.initAnimation = function() {
  const self = this;

  self.animationTL = gsap
    .timeline({
      paused: true,
      reversed: true,
      onStart: () => self.toggleMobileNavState(),
      onReverseComplete: () => self.toggleMobileNavState(),
    })
    .add(self.generateMobileNavTL());

  PubSub.subscribe('openMobileNav', () => self.openMobileNav());
  PubSub.subscribe('closeMobileNav', () => self.closeMobileNav());
};

MobileNav.prototype.toggleMobileNavState = function() {
  const self = this;

  self.data.isOpen = !self.data.isOpen;
};

MobileNav.prototype.openMobileNav = function(speed = 1) {
  const self = this;

  if (self.data.isOpen || self.animationTL.isActive()) return;

  self.animationTL.timeScale(speed).play();
  $('body').addClass('mobile-nav-open');
};

MobileNav.prototype.closeMobileNav = function(speed = 2) {
  const self = this;

  if (!self.data.isOpen || self.animationTL.isActive()) return;

  self.animationTL.timeScale(speed).reverse();
  $('body').removeClass('mobile-nav-open');
};

MobileNav.prototype.toggleMobileNav = function() {
  const self = this;

  self.animationTL.reversed() ? self.openMobileNav() : self.closeMobileNav();
};

export default MobileNav;
